// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const abomasnow_mega: PokeData = {
  "id": 10060,
  "name": "abomasnow-mega",
  "height": 27,
  "weight": 1850,
  "base_experience": 208,
  "types": [
    PokeType.GRASS,
    PokeType.ICE
  ],
  "api_moves": [
    "ice-punch",
    "leer",
    "mist",
    "blizzard",
    "razor-leaf",
    "powder-snow",
    "icy-wind",
    "swagger",
    "ingrain",
    "grass-whistle",
    "sheer-cold",
    "ice-shard",
    "wood-hammer"
  ],
  "moves": [
    "ice-punch",
    "leer",
    "blizzard",
    "razor-leaf",
    "sheer-cold",
    "ice-shard",
    "wood-hammer",
    "bullet-seed",
    "branch-poke",
    "vine-whip",
    "grassy-terrain",
    "aurora-veil",
    "chilly-reception"
  ],
  "evolution_chain": {
    "id": 239,
    "item": null,
    "species": [
      {
        "name": "snover",
        "order": 478,
        "types": [
          PokeType.GRASS,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "abomasnow",
        "order": 479,
        "types": [
          PokeType.GRASS,
          PokeType.ICE
        ],
        "evolves_from_species_id": 459,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 150,
    "speed": 46,
    "ability_power": 203
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
